// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"801c108c","667":"25e0511e"}[chunkId] + ".chunk.js";
};